module.exports = __webpack_public_path__ + "img/heron1.d5967a55.svg";